// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-hangup';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.165 6.54A3.386 3.386 0 0 0 .5 9.854v.648c0 .648.504 1.153 1.153 1.153h2.809c.648 0 1.152-.505 1.152-1.153S6.12 9.35 6.767 9.35h4.466c.648 0 1.153.504 1.153 1.152 0 .648.504 1.153 1.152 1.153h2.81c.648 0 1.152-.505 1.152-1.153v-.648a3.386 3.386 0 0 0-2.665-3.314c-3.962-.72-7.852-.72-11.67 0z'
  />
);

export const viewBox = '0 0 18 18';
